// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupLinkDto
 */
export interface IExpressSetupLinkDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupLinkDto
     */
    privacy_policy_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupLinkDto
     */
    terms_and_conditions_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupLinkDto
     */
    pricing_consent_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupLinkDto
     */
    dark_large_logo_path?: string;
}

/**
 * Check if a given object implements the IExpressSetupLinkDto interface.
 */
export function instanceOfIExpressSetupLinkDto(value: object): value is IExpressSetupLinkDto {
    return true;
}

export function IExpressSetupLinkDtoFromJSON(json: any): IExpressSetupLinkDto {
    return IExpressSetupLinkDtoFromJSONTyped(json, false);
}

export function IExpressSetupLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'pricing_consent_link': json['pricing_consent_link'] == null ? undefined : json['pricing_consent_link'],
        'dark_large_logo_path': json['dark_large_logo_path'] == null ? undefined : json['dark_large_logo_path'],
    };
}

export function IExpressSetupLinkDtoToJSON(json: any): IExpressSetupLinkDto {
    return IExpressSetupLinkDtoToJSONTyped(json, false);
}

export function IExpressSetupLinkDtoToJSONTyped(value?: IExpressSetupLinkDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'privacy_policy_link': value['privacy_policy_link'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'pricing_consent_link': value['pricing_consent_link'],
        'dark_large_logo_path': value['dark_large_logo_path'],
    };
}

